import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MyMerchantAccountsComponent } from './my-merchant-accounts/my-merchant-accounts.component';
import { InvalidMerchantAccountsComponent } from './invalid-merchant-accounts/invalid-merchant-accounts.component';
import { MerchantAccountsComponent } from './merchant-accounts/merchant-accounts.component';
import { CashnetAccountsComponent } from './cashnet-accounts/cashnet-accounts.component';
import { AccountComponent } from './account/account.component';
import { MyMerchantAccountsResolver, StandardAccountsResolver, CashnetAccountsResolver, InvalidMerchantAccountsResolver, MerchantAccountByIdResolver, NewMerchantAccountResolver } from './resolvers';
import { RoleGuard } from '../core';
import { WorkflowNotFoundComponent, WorkflowPackageResolver } from '../shared';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'mine',
        pathMatch: 'full'
    },
    {
        path: 'mine',
        component: MyMerchantAccountsComponent,
        canActivate: [RoleGuard],
        data: { roles: ['BasicUser'] },
        resolve: { merchantAccounts: MyMerchantAccountsResolver }
    },
    {
        path: 'invalid',
        component: InvalidMerchantAccountsComponent,
        canActivate: [RoleGuard],
        data: { roles: ['Admin'] },
        resolve: { merchantAccounts: InvalidMerchantAccountsResolver }
    },
    {
        path: 'standard',
        component: MerchantAccountsComponent,
        canActivate: [RoleGuard],
        data: { roles: ['Admin'] },
        resolve: { merchantAccounts: StandardAccountsResolver }
    },
    {
        path: 'cashnet',
        component: CashnetAccountsComponent,
        canActivate: [RoleGuard],
        data: { roles: ['Admin'] },
        resolve: { merchantAccounts: CashnetAccountsResolver }
    },
    {
        path: 'create',
        component: AccountComponent,
        canActivate: [RoleGuard],
        data: { roles: ['BasicUser'] },
        resolve: { merchantAccount: NewMerchantAccountResolver }
    },
    {
        path: 'signature',
        component: WorkflowNotFoundComponent,
        canActivate: [RoleGuard],
        data: { roles: ['BasicUser'] },
        resolve: { workflow: WorkflowPackageResolver }
    },
    {
        path: ':id',
        component: AccountComponent,
        canActivate: [RoleGuard],
        data: { roles: ['BasicUser'] },
        resolve: { merchantAccount: MerchantAccountByIdResolver }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MerchantAccountRoutingModule { }
